import { API } from '@/BeatoutAPI';
import { moduleActionContext } from '@/store';
import { helpers } from '../helpers';
import { ScheduleTemplate } from '@/types/scheduleTemplates';
const state = {
    templates: {}
};
const getters = {};
const mutations = {
    set(storestate, templates) {
        storestate.templates = templates;
    }
};
const actions = {
    async getTemplates(context) {
        const { commit } = scheduleTemplateModuleActionContext(context);
        const response = await API.getRequest().get(`schedule_templates`);
        const templates = {};
        Object.entries(response.data).forEach(([id, template]) => {
            templates[id] = ScheduleTemplate.load(template);
        });
        commit.set(templates);
    },
    async create(context, template) {
        const { dispatch } = scheduleTemplateModuleActionContext(context);
        const response = await API.getRequest().post(`schedule_template/new`, JSON.stringify(template));
        if (response.status !== 200) {
            return null;
        }
        await dispatch.getTemplates();
        return response.data.id;
    },
    async delete(context, templateId) {
        const { dispatch } = scheduleTemplateModuleActionContext(context);
        const response = await API.getRequest().delete(`schedule_template/${templateId}`);
        if (response.status !== 200) {
            return false;
        }
        await dispatch.getTemplates();
        return true;
    },
    async update(context, params) {
        const { dispatch } = scheduleTemplateModuleActionContext(context);
        const response = await API.getRequest().put(`schedule_template/${params.id}`, JSON.stringify(params.template));
        if (response.status !== 200) {
            return false;
        }
        await dispatch.getTemplates();
        return true;
    },
    async subscribe(context) {
        const { dispatch } = scheduleTemplateModuleActionContext(context);
        await helpers.subscribe(`schedule-templates`, { repeat: 30000 }, async () => {
            dispatch.getTemplates();
        });
    },
    async unsubscribe(_context) {
        await helpers.unsubscribe(`schedule-templates`);
    }
};
const scheduleTemplateModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default scheduleTemplateModule;
export const scheduleTemplateModuleActionContext = (context) => {
    return moduleActionContext(context, scheduleTemplateModule);
};
